module.exports = __webpack_public_path__ + "img/personal_live.c4a877e1.png";